import { useMemo } from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import { normalizeDbTypeColors, typeCategory, typeColorVars, valueCategory } from './dbTypeColors';

/**
 * The grid side of "colour values by column type" (dbTypeColors.js).
 *
 *   rootClass / style → on the grid root: the on/off switch and the colours
 *                       (CSS custom properties, both themes)
 *   catClass(j, value) → ` dbm-td--t-<category>` for a data cell, or ''
 *
 * Column categories are computed once per result; a column without a known
 * type (query tabs) falls back to the value's JS type. NULL keeps its own
 * `.dbm-null` span, coloured through the same variables.
 */
export default function useDbTypeColors(columns, columnTypes) {
  const raw = usePreferencesStore((s) => s.dbTypeColors);
  const pref = useMemo(() => normalizeDbTypeColors(raw), [raw]);
  const colCats = useMemo(
    () => (columns || []).map((c) => typeCategory(columnTypes?.[c])),
    [columns, columnTypes]
  );
  const style = useMemo(() => (pref.enabled ? typeColorVars(pref) : undefined), [pref]);
  const catClass = (j, value) => {
    if (!pref.enabled || value === null || value === undefined) return '';
    const cat = colCats[j] || valueCategory(value);
    return cat && cat !== 'null' ? ` dbm-td--t-${cat}` : '';
  };
  return { rootClass: pref.enabled ? ' dbm-typecolors' : '', style, catClass };
}
